import PropTypes from "prop-types";
import { ProductCollections } from "vino/components";

const Block = ({ attributes }) => {
	return <ProductCollections attributes={attributes} />;
};

Block.propTypes = {
	attributes: PropTypes.object,
};

export default Block;
